import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ContratosService } from '../../services/contratos.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { ContratosEditComponent } from '../contratos-edit/contratos-edit.component';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { CellImageFormatterComponent } from '../cell-image-formatter/cell-image-formatter.component';

@Component({
  selector: 'app-contratos',
  templateUrl: './contratos.component.html',
  styleUrls: ['./contratos.component.scss']
})
export class ContratosComponent implements OnInit {

  public translate: TranslateService;
  public columnDefs: any[];
  private gridApi;

  createColumnDef() {
    const columnDefs = [
      {
        headerName: "Eliminar", field: 'id', suppressFilter: true, suppressSorting: true,
        template:
          `
            <a data-action-type="remove">Borrar</a>`,
        pinned: 'left',
        minWidth: 90
      },
      // { headerName: "Eliminar", field: 'id', suppressFilter: true, suppressSorting: true, template:
      // `<a data-action-type="remove">Borrar</a>`, pinned: 'left',  minWidth: 90 },
      { headerName: this.translate.instant('contratos.ag_id'), field: 'id', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: this.translate.instant('contratos.ag_nombre'), field: 'nombre', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: this.translate.instant('contratos.ag_activo'), field: 'activo', minWidth: 100, cellRendererFramework: CellImageFormatterComponent, cellRendererParams: { modo: "isActivo" } },
      { headerName: this.translate.instant('contratos.ag_tipoContrato'), field: 'tipoContratoId', minWidth: 150 },
      { headerName: this.translate.instant('contratos.ag_fechaEntrada'), field: 'fechaEntrada', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('contratos.ag_fechaExpiracion'), field: 'fechaExpiracion', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('contratos.ag_idTarifa'), field: 'tarifaId', minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdDate'), field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdByName'), field: 'createdByName', minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedDate'), field: 'updatedDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedByName'), field: 'updatedByName', minWidth: 150 },
    ];

    return columnDefs;
  }

  dialogConfig: MatDialogConfig;
  constructor(private _ContratoService: ContratosService, private _router: Router, private _route: ActivatedRoute, private _dialog: MatDialog, _translateService: TranslateService) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
  }

  public defaultColDef = {
    // set every column width
    width: 100,
    // make every column editable
    // make every column use 'text' filter by default
    filter: 'agTextColumnFilter'
  };

  public rowData: any;
  searchTerm: FormControl = new FormControl();

  ngOnInit() {
    this.getData();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  getData() {
    this._ContratoService.getContratosConInactivos().subscribe(data => this.rowData = data);
  }  

  private hasSelectedRow(): boolean {
    console.log(this.gridApi.getSelectedNodes().length);
    return (this.gridApi.getSelectedNodes().length == 1);
  }

  public newItem() {

    let ref = this._dialog.open(ContratosEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      this.getData();
    });
  }

  public onCellClickedEvent($event) {

    if ($event.event.target !== undefined) {
      let data = $event.data;
      let actionType = $event.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);

      }
    }

    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf("grid-opendialog") >= 0) {

      let dlgRef = this._dialog.open(ContratosEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.afterClosed().subscribe(result => {
        this.getData();
      });
    }
  }

  onActionRemoveClick(data: any) {
    var ans = confirm("Quieres eliminar el registro con Id: " + data.id);
    if (ans) {
      this._ContratoService.deleteContrato(data.id).subscribe((data:any) => {
        if (data.estado == "Error") {
          alert("Este contrato está asociado a alguna tasación, por lo que no se puede borrar. Si lo desea puede marcarlo como inactivo.");
        }
        this.getData();
      });
    }
  }
}
